import { BottomSheet } from './BottomSheet';
import { Zap } from 'lucide-react';

export function FidersSheet({ linkedtp, fiders, onClose, onSelect, onBack }) {
  return (
    <BottomSheet title={`Фидеры ${linkedtp}`} onClose={onClose} open={true} onBack={onBack}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {fiders.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#9ca3af', fontSize: '14px', padding: '16px 0' }}>
            Фидеры не найдены
          </p>
        ) : (
          fiders.map((fider) => (
            <button
              key={fider.line_id}
              onClick={() => { onSelect(fider.line_id); onClose(); }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 16px',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                background: '#f9fafb',
                cursor: 'pointer',
                fontSize: '15px',
                fontWeight: 500,
                color: '#1a1a1a',
                width: '100%',
                textAlign: 'left'
              }}
            >
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '10px',
                background: '#eff6ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Zap size={18} color="#3b82f6" />
              </div>
              {fider.fider_name}
            </button>
          ))
        )}
      </div>
    </BottomSheet>
  );
}